export const FULL_MODE = 'fullMode';
export const REGULAR_GUEST_MODE = 'regularGuestMode';
export const SS_GUEST_MODE = 'SSGuestMode';
export const PPS_PURCHASED = 'PPSPurchased';
